import { AuthFeatureKey, AuthFeatureState } from './auth.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectAuthState = createFeatureSelector<AuthFeatureState>(AuthFeatureKey);
export const selectCurrentUser = createSelector(selectAuthState, ({ currentUser }) => currentUser);
export const selectAuthStatus = createSelector(selectAuthState, ({ status }) => status);
